import { useState } from 'react';
import useIsomorphicEffect from '../../hooks/useIsomorphicEffect';

function useWindowSize() {
  const [size, setSize] = useState(
    typeof window === 'undefined' ? [0, 0] : [window?.innerWidth || 0, window?.innerHeight || 0]
  );

  useIsomorphicEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
}

export default useWindowSize;
